import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonHttpService } from 'src/app/common.service';
import { GlobalComponent } from 'src/app/global/global.component';
import { GeneralService } from 'src/app/service/general.service';
import { functionpermission } from '../client-parent/client-parent.model';
import { ClientHttpService } from '../client-parent/client-parent.service';
import { ClientEmployeeContactBO, ClientSupportRelationShipBO, ContactInfoLst, functionpermissionemployee, GetClientEvaluation, getMappedSupportPlannerBO, returnSupportPlannerBO } from './client-employee-contact.model';
import { ClientEmployeeContactService } from './client-employee-contact.service';
import { IMyDpOptions } from 'mydatepicker';
import { DateService } from 'src/app/date.service';
import { DataStateChangeEventArgs, FilterSettingsModel, GridComponent } from '@syncfusion/ej2-angular-grids';
import { ClientSupportRelationDateService } from './client-support-relation.service';

@Component({
  selector: 'app-client-employee-contact',
  templateUrl: './client-employee-contact.component.html',
  styleUrls: ['./client-employee-contact.component.scss']
})
export class ClientEmployeeContactComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  @Input() ContactRelation: ClientEmployeeContactBO;
  savecontactinfo: ContactInfoLst = new ContactInfoLst();
  fpclient: functionpermission = new functionpermission();
  fpemployee: functionpermissionemployee = new functionpermissionemployee();
 @ViewChild('gridsupportrelation') public gridsupportrelation: GridComponent;
  ClientEmployeeContactData: ContactInfoLst[] = [];
  getclientsupport:GetClientEvaluation=new GetClientEvaluation();
  stateList: any = [];

  ContactTypeList: [{ Key: number, Value: string }];
  ContactRelationshipList: [{ Key: number, Value: string }];
  SupportPlannersList: [{ Key: number, Value: string }];
  
  phoneCarrierList: [{ Key: number, Value: string }];
  ContactInfoForm: FormGroup;
  disabledsavedbutton: boolean = false;
  ContactId: any;
  isCheckContactvalue: boolean = false;
  public formatOptions: object

  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
   initialPage: object;
     filterOptions: FilterSettingsModel;   
    public myDatePickerOptions: IMyDpOptions = {
      dateFormat: "mm/dd/yyyy",
      showClearDateBtn: true,
      editableDateField: true,
    };
    ClientSupportRelationShipBO:ClientSupportRelationShipBO=new ClientSupportRelationShipBO();
  public datasupportrealtion: Observable<DataStateChangeEventArgs>;
  constructor(public formBuilder: FormBuilder, public global: GlobalComponent, public clientemployeeContactService
    : ClientEmployeeContactService, public toastrService: ToastrService, public general: GeneralService, public commonhttp: CommonHttpService, public ClientService: ClientHttpService,
    public dateservice:DateService,@Inject(ClientSupportRelationDateService) public clientnotesdateservice: ClientSupportRelationDateService,
  ) {
    this.datasupportrealtion = clientnotesdateservice;
    this.ContactInfoForm = this.formBuilder.group({
      Name: [' ', Validators.required],
      ContactTypes: [' ', Validators.required],
      phoneCarrier: [' ',],
      RelationshipType: [' ',],
      phoneNumber: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      alternatePhoneNumber: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      fax: [' ', [Validators.minLength(14), Validators.maxLength(14)]],
      street: [' '],
      city: [' '],
      email: ['', Validators.email],
      state: [' '],
      zip: [' '],
      clinic: [' ']
    })
  }

  ngOnInit(): void {
    console.log("ContactRelation",this.ContactRelation);
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
    this.filterOptions = { type: 'Menu' };
    if (this.ContactRelation.ContactType == 'Client') {
      this.getpermissionclient();
      this.getClientContactInfo();        
       
    }
    else if (this.ContactRelation.ContactType == 'Employee') {
      this.getpermissionemployee();
      this.getEmployeeContactInfo();
    }
    this.getContactType();
    this.getContactRelationStatus();
    this.getPhoneCarrierStatus();   
    this.formatOptions = { type: 'date', format: 'MM/dd/yyyy' };
        
console.log("ngOninit",this.ContactRelation.Relationtype)
    this.commonhttp.getJSON().pipe(takeUntil(this.onDestroy$)).subscribe(data => {
      this.stateList = data;
    });
  }

  getpermissionclient() {
    let params = new URLSearchParams();
    params.append("pagecode", "Client");
    params.append("roleId", this.global.roleId);
    params.append("agencyId", this.global.globalAgencyId)
    this.ClientService.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (data != null) {
        this.fpclient = data;
      }
      else {
        this.fpclient = new functionpermission();
      }
    },
      (err: HttpErrorResponse) => {
        this.fpclient = new functionpermission();
      })
  }
  getpermissionemployee() {
    let params = new URLSearchParams();
    params.append("pagecode", "employee");
    params.append("roleId", this.global.roleId);
    params.append("agencyId", this.global.globalAgencyId)
    this.ClientService.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (data != null) {
        this.fpemployee = data;
      }
      else {
        this.fpemployee = new functionpermissionemployee();
      }
    },
      (err: HttpErrorResponse) => {
        this.fpemployee = new functionpermissionemployee();
      })
  }

  selectedContactdetails(ContactDetails: ContactInfoLst) {
    this.savecontactinfo = JSON.parse(JSON.stringify(ContactDetails));
  }

  showOrHideAdditionalDetails(index) {
    this.ClientEmployeeContactData[index].showAdditionalDetails = !(this.ClientEmployeeContactData[index].showAdditionalDetails);
  }

  setDeleteId(value) {
    this.ContactId = value;
  }

  getContactType() {
    let params = new URLSearchParams();
    params.append("ListCode", "CONTACTTYPE");
    this.clientemployeeContactService.getLovTypes(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: [{ Key: number, Value: string }]) => {
      this.ContactTypeList = data;
    }, (err: any) => {
      if (err) {
        this.toastrService.error(err, 'Error'), 8000;
      }
    })
  }
  DemographicPhoneFormat() {
    this.savecontactinfo.phoneNumber = this.general.converPhoneGoogleLib(this.savecontactinfo.phoneNumber)
    this.savecontactinfo.alternatePhoneNumber = this.general.converPhoneGoogleLib(this.savecontactinfo.alternatePhoneNumber)
    this.savecontactinfo.fax = this.general.converPhoneGoogleLib(this.savecontactinfo.fax)
  }
  keyPress(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  getContactRelationStatus() {
    let params = new URLSearchParams();
    params.append("ListCode", "RELATIONSHIP");
    this.clientemployeeContactService.getLovTypes(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: [{ Key: number, Value: string }]) => {
      this.ContactRelationshipList = data;
    }, (err: any) => {
      if (err) {
        this.toastrService.error(err, 'Error'), 8000;
      }
    })
  }

  getPhoneCarrierStatus() {
    let params = new URLSearchParams();
    params.append("ListCode", "PHONECARRIER");
    this.clientemployeeContactService.getLovTypes(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.phoneCarrierList = data;
    }, (err: any) => {
      if (err) {
        this.toastrService.error(err, 'Error'), 8000;
      }
    })
  }
  Delete() {
    if (this.ContactRelation.ContactType == 'Client') {
      let param = new URLSearchParams()
      param.append("Id", this.ContactId)
      this.clientemployeeContactService.DeleteCliContactInfo(param).subscribe((data: any) => {
        this.toastrService.success("Contact deleted successfully!");
        document.getElementById("openContactdelete").click();
        this.getClientContactInfo();
      },
        (err: any) => {
          if (err) {
            this.toastrService.error(err, 'Error'), 8000;
          }
        })
    }
    else if (this.ContactRelation.ContactType == 'Employee') {
      let param = new URLSearchParams()
      param.append("Id", this.ContactId)
      this.clientemployeeContactService.DeleteEmpContactInfo(param).subscribe((data: any) => {
        this.toastrService.success("Contact deleted successfully!");
        document.getElementById("openContactdelete").click();
        this.getEmployeeContactInfo();
      },
        (err: any) => {
          if (err) {
            this.toastrService.error(err, 'Error'), 8000;
          }
        })
    }
  }
  getClientContactInfo() {
    let params = new URLSearchParams();
    params.append("ClientId", this.ContactRelation.Id.toString());
    this.clientemployeeContactService.getClientInfoDetails(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.ClientEmployeeContactData = data;
    },
      (err: any) => {
        if (err) {
          this.toastrService.error(err, 'Error'), 8000;
        }
      })
  }
  getEmployeeContactInfo() {
    let params = new URLSearchParams();
    params.append("EmployeeId", this.ContactRelation.Id.toString());
    this.clientemployeeContactService.getEmployeeInfoDetails(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.ClientEmployeeContactData = data;
    },
      (err: any) => {
        if (err) {
          this.toastrService.error(err, 'Error'), 8000;
        }
      })
  }
  SaveOrUpdateContactInfo() {
    this.disabledsavedbutton = true;
    let saveContact: ContactInfoLst = JSON.parse(JSON.stringify(this.savecontactinfo));
    saveContact.id = this.savecontactinfo.id;
    if (this.ContactRelation.ContactType == 'Client') {
      saveContact.clientId = this.ContactRelation.Id;
    }
    else if (this.ContactRelation.ContactType == "Employee") {
      saveContact.employeeId = this.ContactRelation.Id;
    }
    saveContact.contactTypeLid = this.savecontactinfo.contactTypeLid;
    saveContact.relationshipLid = (saveContact.relationshipLid != null && saveContact.relationshipLid != undefined && saveContact.relationshipLid != "") ? this.savecontactinfo.relationshipLid : null;
    saveContact.phoneCarrierLid = (saveContact.phoneCarrierLid != null && saveContact.phoneCarrierLid != undefined && saveContact.phoneCarrierLid != "") ? this.savecontactinfo.phoneCarrierLid : null;
    if (saveContact.alternatePhoneNumber != null) {
      saveContact.alternatePhoneNumber = this.general.reconverPhoneGoogleLib(saveContact.alternatePhoneNumber);
    }
    if (saveContact.fax != null) {
      saveContact.fax = this.general.reconverPhoneGoogleLib(saveContact.fax);
    }
    if (saveContact.phoneNumber != null) {
      saveContact.phoneNumber = this.general.reconverPhoneGoogleLib(saveContact.phoneNumber);
    }
    if (this.ContactRelation.ContactType == 'Client') {
      this.clientemployeeContactService.SaveCliContactInfo(saveContact).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        if (this.savecontactinfo.id == "00000000-0000-0000-0000-000000000000") {
          document.getElementById('openContactModal').click();
          this.toastrService.success('Contact saved successfully!');
          setTimeout(() => {
            this.toastrService.clear();
          }, 8000);
          this.ContactInfoForm.reset();
          this.savecontactinfo.id = "00000000-0000-0000-0000-000000000000"
        }
        else if (this.savecontactinfo.id != "00000000-0000-0000-0000-000000000000") {
          document.getElementById('openContactModal').click();
          this.toastrService.success('Contact updated successfully!');
          setTimeout(() => {
            this.toastrService.clear();
          }, 8000);
          this.ContactInfoForm.reset();
          this.savecontactinfo.id = "00000000-0000-0000-0000-000000000000"
        }
        this.disabledsavedbutton = false;
        this.getClientContactInfo();
      }, (err: any) => {
        this.disabledsavedbutton = false;
        if (err) {
          this.toastrService.error(err, 'Error'), 8000;
        }
      })
    }
    else if (this.ContactRelation.ContactType == "Employee") {
      this.clientemployeeContactService.SaveEmpContactInfo(saveContact).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        if (this.savecontactinfo.id == "00000000-0000-0000-0000-000000000000") {
          document.getElementById('openContactModal').click();
          this.toastrService.success('Contact saved successfully!');
          setTimeout(() => {
            this.toastrService.clear();
          }, 8000);
          this.ContactInfoForm.reset();
          this.savecontactinfo.id = "00000000-0000-0000-0000-000000000000"
        }
        else if (this.savecontactinfo.id != "00000000-0000-0000-0000-000000000000") {
          document.getElementById('openContactModal').click();
          this.toastrService.success('Contact updated successfully!');
          setTimeout(() => {
            this.toastrService.clear();
          }, 8000);
          this.ContactInfoForm.reset();
          this.savecontactinfo.id = "00000000-0000-0000-0000-000000000000"
        }
        this.disabledsavedbutton = false;
        this.getEmployeeContactInfo();
      }, (err: any) => {
        this.disabledsavedbutton = false;
        if (err) {
          this.toastrService.error(err, 'Error'), 8000;
        }
      })
    }
  }

  isContactChange() {
    this.isCheckContactvalue = true;
  }

  TypeContactValueChange() {
    if (this.isCheckContactvalue == true) {
      document.getElementById('typemodal').click();
    }
    else {
      this.savecontactinfo.id = "00000000-0000-0000-0000-000000000000"
      document.getElementById("openContactModal").click();
      this.ContactInfoForm.reset();
      this.isCheckContactvalue = false;

    }
  }

  closetype() {
    document.getElementById('typemodal').click();
  }

  backtoContact() {
    this.savecontactinfo.id = "00000000-0000-0000-0000-000000000000"
    document.getElementById('typemodal').click();
    document.getElementById("openContactModal").click();
    this.ContactInfoForm.reset();
    this.isCheckContactvalue = false;
  }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  clickaddContact() {
    this.savecontactinfo = new ContactInfoLst();
  }
 
    //.......................................DateFormat.................................................
    DateFormat(event, type, name) {
      if (type == "inputchanged") {
        if (name == "SaveStartDate") {
          let val = this.dateservice.inputFeildchangeReturnall(event);
          if (val != undefined) {
            let element = this.dateservice.inputFeildchangeReturnall(event);
            this.ClientSupportRelationShipBO.activeDate = element;

          }
        }
        if (name == "SaveEndDate") {
          let val = this.dateservice.inputFeildchangeReturnall(event);
          if (val != undefined) {
            let element = this.dateservice.inputFeildchangeReturnall(event);
            this.ClientSupportRelationShipBO.inActiveDate = element;
          }
        }
      }
      if (type == "datechanged") {
        if (name == "SaveStartDate") {
          let val = this.dateservice.Datechange(event);
          if (val != undefined) {
            let element = this.dateservice.Datechange(event);
            this.ClientSupportRelationShipBO.activeDate = element;
          }
        }
        if (name == "SaveEndDate") {
          let val = this.dateservice.Datechange(event);
          if (val != undefined) {
            let element = this.dateservice.Datechange(event);
            this.ClientSupportRelationShipBO.inActiveDate = element;
          }
        }
      }
    }

    public onActionComplete(args) {


  this.getclientsupport.currentpageno = this.gridsupportrelation.pageSettings.currentPage;
  this.getclientsupport.pageitem = this.gridsupportrelation.pageSettings.pageSize;
  if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
    this.getclientsupport.type = args.columnType;
  }
  if(args.requestType == "sorting"){
    if(args.columnName == null || args.columnName == undefined){
      this.getclientsupport.orderColumn = 'notes';
      this.getclientsupport.orderType = 'asc'
    }else{
      this.getclientsupport.orderColumn = (args.columnName != null && args.columnName != undefined)? args.columnName : 'notes';
      this.getclientsupport.orderType = (args.direction == "Ascending")? 'asc' : 'desc';
    }
  }

  this.getclientsupport.currentpageno = this.gridsupportrelation.pageSettings.currentPage;
  this.getclientsupport.pageitem = this.gridsupportrelation.pageSettings.pageSize;
  // this.conditionlist = [];
  // if (args.requestType === "filtering" && args.action === "filter") {
  //   args.columns.forEach(element => {
  //     this.conditionlist.push(element.properties);
  //   });
  // }

}

 
}




